import Swal from 'sweetalert2'

import request from '../request'
import store from '../store'
import { setPaymentMethods, setGlobalIsPending } from '../store/actions'
import { storage, constants } from '../utils'
import { tips } from '../locales'
import { routes } from '../config'
import extrasFiles from '../extrasFiles'

const setB3PaymentMethods = async (companyId: string) => {

  if (localStorage.getItem('IPCheckout') === '1') {
    const { allowedMethods } = await request.api.getIPPaymentMethods()
    store.dispatch(setPaymentMethods(allowedMethods))
    return
  }

  const methods = await request.api.getPaymentMethods(companyId)

  const enabledMethods = methods.filter(method => method.isEnabled === constants.B3PaymentMethodPermission.isEnabled)
  store.dispatch(setPaymentMethods(enabledMethods))
}

const addPoNumber = async (orderId: any) => {
  const poNumber = storage.B3PoNumber.getValue() || ''
  const referenceNumber = storage.B3PaymentsAdditionalTextFieldValue.getValue() || ''

  let extraFields: any = []
  const customFields = JSON.parse(localStorage.getItem('B3PaymentCustomFields') || '{}')
  if (customFields && JSON.stringify(customFields) !== '{}') {
    extraFields = Object.keys(customFields).map((item: any) => {
        return {
            fieldName: item,
            fieldValue: customFields[item]
        }
    })
  }

  let extraInfo = extrasFiles.getShippingAndBillingFields()

  if (!orderId) return

  try {
    store.dispatch(setGlobalIsPending(true))
    await request.api.addPoNumber({
      orderId,
      poNumber,
      referenceNumber,
      extraFields,
      extraInfo,
    })
  }
  finally {
    store.dispatch(setGlobalIsPending(false))
    storage.B3PoNumber.removeValue()
    storage.B3OrderExtras.removeValue()
    storage.B3BillingAddressExtras.removeValue()
    storage.B3ShippingAddressExtras.removeValue()
    storage.B3DefaultAddressExtras.removeValue()
    storage.B3PaymentsAdditionalTextFieldValue.removeValue()
    localStorage.removeItem('B3PaymentCustomFields')
    localStorage.removeItem('B3ShippingCustomFields')
    localStorage.removeItem('B3BillingCustomFields')
  }
}

const checkoutQuote = async (orderId: any, storeHash: string, checkout: any,) => {
  const quoteId = localStorage.getItem('quoteCheckoutId')
  if (!orderId || !quoteId) return
  const { consignments, shippingCostTotal, taxTotal } = checkout
  const params = {
    orderId,
    storeHash,
    shippingTotal: shippingCostTotal,
    taxTotal,
    shippingMethod: consignments[0].selectedShippingOption,
    shippingAddress: {
      country: consignments[0].shippingAddress.country,
      state: consignments[0].shippingAddress.stateOrProvince,
      city: consignments[0].shippingAddress.city,
      zipCode: consignments[0].shippingAddress.postalCode,
      address: consignments[0].shippingAddress.address1,
      apartment: consignments[0].shippingAddress.address2,
      firstName: consignments[0].shippingAddress.firstName,
      lastName: consignments[0].shippingAddress.lastName,
    },
  }
  try {
    store.dispatch(setGlobalIsPending(true))
    await request.api.checkoutQuote(quoteId, params)
  }
  finally {
    store.dispatch(setGlobalIsPending(false))
    localStorage.removeItem('quoteCheckoutId')
  }
}

const getIPOrderPaymentId = async (orderId: any) => {
  try{
    store.dispatch(setGlobalIsPending(true))
    const { receiptId } = await request.api.getIPOrderPaymentId({ orderId })
    window.location.href = `${location.origin}/invoice-payment-receipt/?id=${receiptId}`
  }
  finally{
    store.dispatch(setGlobalIsPending(false))
    localStorage.removeItem('IPCheckout')
    localStorage.removeItem('IPCartId')
  }
}

export const paySubmit = async (order: any, storeHash: any, checkout: any) => {
  let isInvoice = false
  if (order?.orderId && localStorage.getItem('IPCheckout') !== '1') {
    await addPoNumber(order.orderId)
  }

  if (order?.orderId) {
      await checkoutQuote(order.orderId, storeHash, checkout)
      if (localStorage.getItem('IPCheckout') === '1') { 
          await getIPOrderPaymentId(order.orderId)
          isInvoice = true
      }
  }
  storage.B3OrderExtras.removeValue()
  return isInvoice
}

const init = async () => {
  const {
    global: {
      isB3User
    }
  } = store.getState()

  if (!isB3User) return

  const companyId = storage.B3CompanyId.getValue()
  if (!companyId) {
    await Swal.fire({
      icon: 'error',
      text: tips['b3.salesRep.notMasquerading'],
      allowOutsideClick: false,
      allowEscapeKey: false,
    })
    location.href = routes.dashboard
    return Promise.reject()
  }

  setB3PaymentMethods(companyId)
}

export default {
  init,
  addPoNumber,
  checkoutQuote,
  getIPOrderPaymentId,
  paySubmit,
}